/* Narthex: zuverlaessiger Autoplay fuer Horizon-Slideshows.
   Horizons eigener Timer stirbt, sobald pause() einmal lief (Tab-Wechsel,
   Wischen, Mausrutscher beim Klick), weil resume() bei gesetztem "paused"
   nichts mehr tut. Ausserdem haengt :hover auf Touch-Geraeten nach einem Tipp.
   Hier laeuft darum ein eigener Takt, der nur noch auf den echten Pause-Knopf,
   verstecktes Tab, laufendes Ziehen und (auf Maus-Geraeten) Hover Ruecksicht nimmt. */
(function () {
  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  function arm(el) {
    if (el.__nxArmed) return;
    var seconds = parseInt(el.getAttribute('autoplay'), 10);
    if (!seconds) return;
    /* nur eine Slide: nichts weiterschalten */
    if (el.querySelectorAll('slideshow-slide').length < 2) return;
    el.__nxArmed = true;
    var userPaused = false;

    /* Horizons eigenen Timer stilllegen, sonst springt der Slider doppelt */
    el.play = function () { userPaused = false; };
    el.pause = function () {};
    if (typeof el.suspend === 'function') el.suspend();

    el.addEventListener('click', function (ev) {
      var b = ev.target.closest('button');
      if (!b) return;
      var oc = b.getAttribute('on:click') || '';
      if (oc === '/pause') { userPaused = true; el.setAttribute('paused', ''); }
      else if (oc === '/play') { userPaused = false; el.removeAttribute('paused'); }
    });

    setInterval(function () {
      if (userPaused || document.hidden) return;
      if (el.hasAttribute('dragging') || el.hasAttribute('transitioning')) return;
      if (canHover && el.matches(':hover')) return;
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      if (typeof el.next === 'function') el.next();
    }, seconds * 1000);
  }

  function armAll() {
    document.querySelectorAll('.slideshow-section slideshow-component[autoplay]').forEach(arm);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', armAll);
  else armAll();
  /* Section-Rendering im Theme-Editor oder nach Navigation */
  document.addEventListener('shopify:section:load', armAll);
  setTimeout(armAll, 1500);

  /* Handy: der Startseiten-Hero fuellt den Bildschirm unter Header und Ankuendigungsleiste */
  function heroHeight() {
    var sec = document.querySelector('[id$="__hero_jVaWmY"]');
    if (!sec) return;
    if (window.innerWidth > 749) { sec.style.removeProperty('--nx-hero-h'); return; }
    var top = sec.getBoundingClientRect().top + window.scrollY;
    var h = Math.max(420, Math.round(window.innerHeight - top));
    sec.style.setProperty('--nx-hero-h', h + 'px');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', heroHeight);
  else heroHeight();
  window.addEventListener('load', heroHeight);
  /* Kopfzeile und Ankuendigungsleiste koennen nach dem ersten Rechnen noch wachsen
     (Logo-Abstaende, Schriften), dann neu rechnen */
  if ('ResizeObserver' in window) {
    var watchHeader = function () {
      var ro = new ResizeObserver(heroHeight);
      document.querySelectorAll('.header, .announcement-bar').forEach(function (el) { ro.observe(el); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchHeader);
    else watchHeader();
  }
  var lastW = window.innerWidth;
  /* nur bei echter Breitenaenderung, sonst springt der Hero beim Scrollen (Adressleiste) */
  window.addEventListener('resize', function () { if (window.innerWidth !== lastW) { lastW = window.innerWidth; heroHeight(); } });
})();
